import { render } from "./EditOption.vue?vue&type=template&id=2d222018"
import script from "./EditOption.vue?vue&type=script&lang=js"
export * from "./EditOption.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__